import request from '@/utils/request'

export function fetchModelPrices() {
  return request.get('/api/model-prices')
}

export function createModelPrice(data) {
  return request.post('/api/model-prices', data)
}

export function updateModelPrice(id, data) {
  return request.put(`/api/model-prices/${id}`, data)
}

export function deleteModelPrice(id) {
  return request.delete(`/api/model-prices/${id}`)
}
